import { Injectable } from "@angular/core";
import { AgGridGroupHeaderTooltipComponent } from "src/shared/ag-grid-components/ag-grid-group-header-tooltip/ag-grid-group-header-tooltip.component";
import { AgGridHelperServiceBase } from "src/shared/services/ag-grid-helper-service-base";

@Injectable({
    providedIn: 'root'
})
export class AgGridHelperService extends AgGridHelperServiceBase {
    constructor() {
        super(true);

        const base = AgGridHelperServiceBase.getServiceBase();
        base.baseGridOptions.columnTypes.groupColumn.tooltipComponent = AgGridGroupHeaderTooltipComponent;
        base.baseGridOptions.columnTypes.groupColumn.headerTooltip = "INPARAMS"; // value not used but this ensures that header tooltips exist
        // base.baseGridOptions.tooltipShowDelay = 1000; // may add in if they want the tooltip to be displayed slower
    }
}
